/*
    Create By Liangyu 2015-10-19
*/
'use strict';
angular.module('logManageMentRouterModule', [])
    .config(['$stateProvider', function($stateProvider) {
        $stateProvider
            .state('manageconfig.logmanage', {
                url: '/logmanage',
                views: {
                    'main@manageconfig': {
                        templateUrl: './manageConfig/logManageMent/iframe_tpl.html',
                        controller: 'logManageMentIframeCtrl'
                    }
                }
            });
    }]);
